import React, { useContext } from 'react'
import styles from './profile-permission-head.styles'
import injectSheet from 'react-jss'
import CircleStatus from 'pobble-components/dist/circle-status'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCheck } from '@fortawesome/pro-solid-svg-icons/faFileCheck'
import { faFileTimes } from '@fortawesome/pro-solid-svg-icons/faFileTimes'
import { AppContext } from '../../../../../app/app'

const ProfilePermissionHead = ({
  classes,
  pupilName,
  permission,
  canUpdatePermission,
  addPermission,
  removePermission,
  pending
}) => {
  const { permissionWarning } = useContext(AppContext)

  return (
    <div className={classes.container}>
      <p className={classes.title}>Permission to Pobble</p>
      <div className={classes.holder}>
        <CircleStatus className={classes.icon} status={permission} />
        {permission && (
          <span>
            {pupilName} has permission to publish and comment on Pobble
          </span>
        )}
        {!permission && (
          <span>
            {pupilName} doesn't have permission to publish and comment on Pobble
          </span>
        )}
      </div>
      {canUpdatePermission && (
        <div className={classes.manualUpdate}>
          {!permission && (
            <Button
              pending={pending}
              action={() => permissionWarning({ action: addPermission })}
              icon={<FontAwesomeIcon icon={faFileCheck} />}
              tall
              secondary>
              Add permission
            </Button>
          )}
          {permission && (
            <Button
              pending={pending}
              action={() => permissionWarning({ action: removePermission })}
              icon={<FontAwesomeIcon icon={faFileTimes} />}
              tall
              secondary>
              Remove permission
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default injectSheet(styles)(ProfilePermissionHead)
